<template>
  <el-dialog :visible.sync="dialogVisible" title="确认退款金额" center width="600px">
    <el-form ref="payFormModal2" :model="form" label-suffix=":" class="payFormModal" label-width="130px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务费率">{{ source.rate }}%</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="商户号退款金额">￥{{ $formatCurrency(source.mch_price) }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="退还服务费">￥{{ $formatCurrency(source.service_price) }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实际退款金额">￥{{ $formatCurrency(source.withdrawal_price) }}</el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="调整后服务费">￥{{ $formatCurrency(source.check_log.final_service_price) }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调整后退款金额">￥{{ $formatCurrency(source.withdrawal_price + source.check_log.adjust_price) }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="调整金额">￥{{ $formatCurrency(source.check_log.adjust_price) }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注">{{ source.check_log.remark }}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template v-slot:footer class="text-center">
      <el-button @click="submitForm('-1')">拒绝</el-button>
      <el-button type="primary" @click="submitForm('1')">同意</el-button>
    </template>
  </el-dialog>
</template>
<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        withdrawal_id: 0,
        check_log_id: 0,
        status: 0
      }
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value
    },
    dialogVisible(value) {
      !value && this.$emit('update:visible', false)
    },
    source: {
      handler(val) {
        if (val.withdrawal_id) {
          this.form.withdrawal_id = val.withdrawal_id
          this.form.check_log_id = val.check_log.id
        } else {
          this.form.withdrawal_id = 0
          this.form.check_log_id = 0
        }
      },
      deep: true
    }
  },
  methods: {
    async submitForm($status) {
      this.form.status = $status
      this.$emit('checkFn', this.form)
    }
  }
}
</script>
<style lang='scss' scoped>
.column{
  .tit{
    width: 90px;
    text-align: right;
  }
  .right-box{
    padding-left: 10px;
    box-sizing: border-box;
  }
}
::v-deep{
  .el-form-item{
    margin-bottom: 8px;
  }
}
</style>
